import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ICommentService = ( createDecorator('commentService'));
export { ICommentService };
